import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import icons from './icons';
import iconsOld from './old/svgIcons';
import styles from './Icon.scss';

const Icon = ({ className, name }) => {
  const cx = classNames.bind(styles);

  if (icons[name] || iconsOld[name]) {
    if (iconsOld[name]) {
      return (
        <i
          className={cx('iconOld', name, className)}
          data-testid="icon-wrapper-old"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: iconsOld[name] }}
        />
      );
    }
    const IconSvg = icons[name];

    return (
      <i className={cx('icon', name, className)} data-testid="icon-wrapper">
        <IconSvg focusable="false" />
      </i>
    );
  }

  return null;
};

const iconsList = [...Object.keys(icons), ...Object.keys(iconsOld)];

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.oneOf(iconsList).isRequired,
};

export default Icon;
